module.exports = __webpack_public_path__ + "img/tp4.7a6d1865.png";